// import { useFormik } from "formik";
// import * as Yup from "yup";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-hot-toast";
// import api from "../api/axiosInstance";
// import { uploadToCloudinary } from "../utils/cloudinaryUpload";
// import { useEffect, useState } from "react";

// const DefenceOfficer = ({ category }) => {
//   const [showOtpModal, setShowOtpModal] = useState(false);
//   const [otp, setOtp] = useState("");
//   const [isVerifying, setIsVerifying] = useState(false);
//   const [isSendingOtp, setIsSendingOtp] = useState(false);
//   const [formData, setFormData] = useState(null);
//   const [cooldownSeconds, setCooldownSeconds] = useState(0); // Add this line
//   const [cooldownInterval, setCooldownInterval] = useState(null); // Add this line

//   // Form validation schema
//   const validationSchema = Yup.object().shape({
//     membershipType: Yup.string()
//       .required("Membership type is required")
//       .notOneOf(["Select Type of Membership"], "Membership type is required"),
//     rank: Yup.string().required("Rank is required"),
//     baNumber: Yup.string().required("BA Number is required"),
//     firstName: Yup.string().required("First Name is required"),
//     lastName: Yup.string().required("Last Name is required"),
//     fatherOrHusbandName: Yup.string().required(
//       "Father's / Husband's Name is required"
//     ),
//     nationality: Yup.string().required("Nationality is required"),
//     occupation: Yup.string().required("Occupation is required"),
//     bloodGroup: Yup.string().required("Blood Group is required"),
//     mobile: Yup.string()
//       .required("Mobile number is required")
//       .matches(/^[0-9]+$/, "Must be only digits")
//       .min(11, "Must be at least 11 digits"),
//     officialAddress: Yup.string().required("Official Address is required"),
//     presentAddress: Yup.string().required("Present Address is required"),
//     permanentAddress: Yup.string().required("Permanent Address is required"),
//     monthlyIncome: Yup.number().required("Monthly Income is required"),
//     incomeTaxReturn: Yup.string().required("Tax return document is required"),

//     nationalId: Yup.string().required("National ID is required"),
//     nidName: Yup.string().required("NID Name is required"),
//     nidFathersName: Yup.string().required(
//       "Father's Name (from NID) is required"
//     ),
//     nidMothersName: Yup.string().required(
//       "Mother's Name (from NID) is required"
//     ),
//     nidDob: Yup.date().required("Date of Birth (from NID) is required"),
//     nidCopy: Yup.string().required("NID image is required"),
//     photo: Yup.string().required("Photo is required"),

//     email: Yup.string().email("Invalid email").required("Email is required"),
//   });

//   const navigate = useNavigate();
//   // const [message, setMessage] = useState("");

//   // Formik setup
//   const formik = useFormik({
//     initialValues: {
//       // category: "Select Category of Applicant",
//       membershipType: "Select Type of Membership",
//       rank: "",
//       baNumber: "",
//       firstName: "",
//       lastName: "",
//       fatherOrHusbandName: "",
//       nationality: "",
//       occupation: "",
//       bloodGroup: "",
//       mobile: "",
//       officialAddress: "",
//       presentAddress: "",
//       permanentAddress: "",
//       monthlyIncome: "",
//       incomeTaxReturn: "",
//       nationalId: "",
//       nidName: "",
//       nidFathersName: "",
//       nidMothersName: "",
//       nidDob: "",
//       nidCopy: "",
//       spouseName: "",
//       spouseOccupation: "",
//       spouseAddress: "",
//       children: [],
//       golfClubMembership: "",
//       officialHandicap: "",
//       photo: "",

//       email: "",
//     },
//     validationSchema,
//     // onSubmit: async (values, { setSubmitting }) => {
//     //   console.log("Form submission started");
//     //   console.log("Form values:", values);
//     //   try {
//     //     setSubmitting(true);

//     //     // Filter out empty children
//     //     const filteredChildren = values.children.filter(
//     //       (child) => child.name.trim() !== ""
//     //     );

//     //     const submissionData = {
//     //       ...values,
//     //       category: category,
//     //       children: filteredChildren.length > 0 ? filteredChildren : undefined,
//     //     };

//     //     // FIX: Correct axios response handling
//     //     const response = await api.post(
//     //       "/registration/membership",
//     //       submissionData
//     //     );

//     //     // Check for successful response
//     //     if (response.status === 201) {
//     //       toast.success(
//     //         "Registration submitted! Please check your email for verification."
//     //       );

//     //       navigate("/verify-email", {
//     //         state: {
//     //           email: values.email,
//     //         },
//     //       });

//     //       // setMessage(response.data.message);
//     //       console.log(response.data);
//     //     } else {
//     //       toast.error(response.data.message || "Registration failed");
//     //     }
//     //   } catch (error) {
//     //     console.error("Registration error:", error);

//     //     if (error.response) {
//     //       // Server responded with error status
//     //       toast.error(
//     //         error.response.data?.message ||
//     //           "An error occurred during registration. Please try again."
//     //       );
//     //     } else if (error.request) {
//     //       // Request was made but no response received
//     //       toast.error("Network error. Please check your connection.");
//     //     } else {
//     //       // Something else happened
//     //       toast.error("An unexpected error occurred.");
//     //     }
//     //   } finally {
//     //     setSubmitting(false);
//     //   }
//     // },
//     onSubmit: async (values, { setSubmitting }) => {
//       console.log("Form submission started");
//       console.log("Form values:", values);
//       try {
//         setSubmitting(true);

//         // First check if we can send OTP (cooldown and existing registration)
//         try {
//           const cooldownResponse = await api.get("/verification/cooldown", {
//             params: { email: values.email },
//           });

//           if (!cooldownResponse.data.canSendOtp) {
//             const seconds = cooldownResponse.data.cooldownSeconds;
//             setCooldownSeconds(seconds);
//             startCooldownTimer(seconds);
//             toast.error(
//               `Please wait ${seconds} seconds before requesting another code`
//             );
//             return;
//           }
//         } catch (cooldownError) {
//           console.log(
//             "Cooldown check failed, proceeding anyway:",
//             cooldownError
//           );
//         }

//         // Store form data for later submission
//         setFormData(values);

//         // Send OTP to email
//         setIsSendingOtp(true);
//         await api.post("/verification/send-otp", null, {
//           params: { email: values.email },
//         });

//         toast.success("Verification code sent to your email");
//         setShowOtpModal(true);
//       } catch (error) {
//         console.error("Error sending OTP:", error);
//         console.error("Full error object:", error);
//         console.error("Error response:", error.response);

//         // Handle specific error messages from backend
//         // if (error.response?.data) {
//         //   toast.error(error.response.data.message);
//         // } else if (error.response?.status === 409) {
//         //   toast.error(
//         //     "Email already registered. Please use a different email."
//         //   );
//         // } else if (error.response?.status === 400) {
//         //   toast.error(
//         //     "Please wait before requesting another verification code."
//         //   );
//         // } else {
//         //   toast.error("Failed to send verification code. Please try again.");
//         // }
//         // Enhanced error handling
//         if (error.response?.data) {
//           // Check for specific error messages from backend
//           const errorMessage = error.response.data;

//           if (typeof errorMessage === "string") {
//             if (errorMessage.includes("EMAIL_ALREADY_REGISTERED")) {
//               toast.error(
//                 "Email already registered. Please use a different email or login."
//               );
//             } else if (errorMessage.includes("OTP_COOLDOWN_ACTIVE")) {
//               toast.error(
//                 "Please wait before requesting another verification code."
//               );
//             } else {
//               toast.error(errorMessage);
//             }
//           } else if (errorMessage.message) {
//             // Handle object response with message field
//             toast.error(errorMessage.message);
//           }
//         } else if (error.response?.status === 409) {
//           toast.error(
//             "Email already registered. Please use a different email."
//           );
//         } else if (error.response?.status === 400) {
//           toast.error(
//             "Please wait before requesting another verification code."
//           );
//         } else if (error.message) {
//           // Handle runtime errors from backend
//           if (error.message.includes("EMAIL_ALREADY_REGISTERED")) {
//             toast.error(
//               "Email already registered. Please use a different email."
//             );
//           } else if (error.message.includes("OTP_COOLDOWN_ACTIVE")) {
//             toast.error(
//               "Please wait before requesting another verification code."
//             );
//           } else {
//             toast.error(error.message);
//           }
//         } else {
//           toast.error("Failed to send verification code. Please try again.");
//         }
//       } finally {
//         setSubmitting(false);
//         setIsSendingOtp(false);
//       }
//     },
//   });

//   const handleOtpVerification = async () => {
//     if (!otp || otp.length !== 6) {
//       toast.error("Please enter a valid 6-digit code");
//       return;
//     }

//     try {
//       setIsVerifying(true);
//       await api.post("/verification/verify-otp", null, {
//         params: {
//           email: formData.email,
//           code: otp,
//         },
//       });

//       toast.success("Email verified successfully!");

//       // Now submit the registration with verified email
//       const filteredChildren = formData.children.filter(
//         (child) => child.name.trim() !== ""
//       );

//       const submissionData = {
//         ...formData,
//         category: category,
//         children: filteredChildren.length > 0 ? filteredChildren : undefined,
//       };

//       const response = await api.post(
//         "/registration/membership",
//         submissionData,
//         {
//           params: { emailVerificationToken: otp },
//         }
//       );

//       if (response.status === 201) {
//         toast.success("Registration submitted successfully!");
//         navigate("/email-verified");
//       }
//     } catch (error) {
//       console.error("Verification error:", error);
//       toast.error(
//         error.response?.data?.message ||
//           "Verification failed. Please try again."
//       );
//     } finally {
//       setIsVerifying(false);
//     }
//   };

//   const handleResendOtp = async () => {
//     try {
//       // Check cooldown first
//       if (cooldownSeconds > 0) {
//         toast.error(
//           `Please wait ${cooldownSeconds} seconds before requesting another code`
//         );
//         return;
//       }

//       setIsSendingOtp(true);
//       await api.post("/verification/send-otp", null, {
//         params: { email: formData.email },
//       });

//       // Start cooldown timer (60 seconds)
//       startCooldownTimer(60);
//       toast.success("New verification code sent!");
//     } catch (error) {
//       console.error("Error resending OTP:", error);

//       if (error.response?.data?.message) {
//         toast.error(error.response.data.message);
//       } else {
//         toast.error("Failed to resend code. Please try again.");
//       }
//     } finally {
//       setIsSendingOtp(false);
//     }
//   };

//   // Helper functions for children fields
//   const addChild = () => {
//     // formik.setFieldValue("children", [
//     //   ...formik.values.children,
//     //   { name: "", dob: "", gender: "", honorary: false },
//     // ]);
//     if (
//       formik.values.children.length === 0 ||
//       formik.values.children[formik.values.children.length - 1].name.trim() !==
//         ""
//     ) {
//       formik.setFieldValue("children", [
//         ...formik.values.children,
//         { name: "", dob: "", gender: "" },
//       ]);
//     }
//   };

//   const removeChild = (index) => {
//     const updated = [...formik.values.children];
//     updated.splice(index, 1);
//     // formik.setFieldValue("children", updated);
//     formik.setFieldValue("children", updated.length > 0 ? updated : undefined);
//   };

//   // Add these helper functions after removeChild function
//   // Cooldown timer functions
//   const startCooldownTimer = (seconds) => {
//     setCooldownSeconds(seconds);

//     const interval = setInterval(() => {
//       setCooldownSeconds((prev) => {
//         if (prev <= 1) {
//           clearInterval(interval);
//           return 0;
//         }
//         return prev - 1;
//       });
//     }, 1000);

//     setCooldownInterval(interval);
//   };

//   const clearCooldownTimer = () => {
//     if (cooldownInterval) {
//       clearInterval(cooldownInterval);
//       setCooldownInterval(null);
//     }
//     setCooldownSeconds(0);
//   };

//   // Clean up interval on component unmount
//   useEffect(() => {
//     return () => {
//       if (cooldownInterval) {
//         clearInterval(cooldownInterval);
//       }
//     };
//   }, [cooldownInterval]);

//   // Max file size in bytes (2 MB )
//   const MAX_FILE_SIZE = 5 * 1024 * 1024; // 2MB

//   const handleFileChange = (fieldName) => async (event) => {
//     const file = event.currentTarget.files[0]; // single file
//     if (file) {
//       if (!file.type.startsWith("image/")) {
//         toast.error("Only image files are allowed");
//         formik.setFieldError(fieldName, "Only image files are allowed");
//         return;
//       }

//       if (file.size > MAX_FILE_SIZE) {
//         toast.error(`File size must not exceed 2MB`);
//         formik.setFieldError(fieldName, "File size must not exceed 2MB");
//         return;
//       }
//       const url = await uploadToCloudinary(file);
//       formik.setFieldValue(fieldName, url); // store Cloudinary URL
//     }
//   };

//   return (
//     <div className="bg-[#fffdf7] py-20 px-6 md:px-20">
//       {/* <h1 className="text-4xl font-bold text-center text-black mb-12">
//         Membership Registration
//       </h1> */}
//       <form onSubmit={formik.handleSubmit}>
//         {showOtpModal && (
//           <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//             <div className="bg-white rounded-lg p-8 max-w-md w-full mx-4">
//               <h3 className="text-2xl font-bold mb-4 text-center">
//                 Verify Your Email
//               </h3>
//               <p className="text-gray-600 mb-6 text-center">
//                 Enter the 6-digit verification code sent to{" "}
//                 <span className="font-semibold">{formData?.email}</span>
//               </p>

//               <div className="flex justify-center space-x-2 mb-6">
//                 {[...Array(6)].map((_, index) => (
//                   <input
//                     key={index}
//                     type="text"
//                     maxLength={1}
//                     className="w-12 h-12 text-center text-2xl border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-lime-400"
//                     value={otp[index] || ""}
//                     onChange={(e) => {
//                       const newOtp = otp.split("");
//                       newOtp[index] = e.target.value;
//                       setOtp(newOtp.join(""));

//                       // Auto-focus next input
//                       if (e.target.value && index < 5) {
//                         document.getElementById(`otp-${index + 1}`).focus();
//                       }
//                     }}
//                     onKeyDown={(e) => {
//                       if (e.key === "Backspace" && !otp[index] && index > 0) {
//                         document.getElementById(`otp-${index - 1}`).focus();
//                       }
//                     }}
//                     id={`otp-${index}`}
//                   />
//                 ))}
//               </div>

//               <div className="flex space-x-3">
//                 <button
//                   type="button"
//                   onClick={() => {
//                     setShowOtpModal(false);
//                     setOtp("");
//                     clearCooldownTimer(); // Clear timer when modal closes
//                   }}
//                   className="flex-1 bg-gray-300 hover:bg-gray-400 text-gray-800 py-2 rounded-md font-semibold transition"
//                   disabled={isVerifying}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="button"
//                   onClick={handleOtpVerification}
//                   className="flex-1 bg-lime-400 hover:bg-black hover:text-white py-2 rounded-md font-semibold transition"
//                   disabled={isVerifying || otp.length !== 6}
//                 >
//                   {isVerifying ? "Verifying..." : "Verify & Register"}
//                 </button>
//               </div>

//               <div className="text-center mt-4">
//                 <button
//                   type="button"
//                   onClick={handleResendOtp}
//                   className={`text-sm ${
//                     cooldownSeconds > 0
//                       ? "text-gray-400 cursor-not-allowed"
//                       : "text-lime-600 hover:text-lime-800"
//                   }`}
//                   disabled={isSendingOtp || cooldownSeconds > 0}
//                 >
//                   {isSendingOtp
//                     ? "Sending..."
//                     : cooldownSeconds > 0
//                     ? `Resend available in ${cooldownSeconds}s`
//                     : "Resend Code"}
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//         <div className="max-w-6xl mx-auto bg-[#fcfaec] rounded-xl p-6 md:p-10 space-y-10">
//           {/* Section 1: Category & Type */}
//           <section>
//             <h2 className="text-2xl font-bold mb-4 text-black">
//               Membership Category & Type
//             </h2>
//             <div className="grid md:grid-cols-2 gap-4">
//               <div>
//                 <select
//                   className="p-3 bg-white rounded w-full outline-none"
//                   name="membershipType"
//                   value={formik.values.membershipType}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                 >
//                   <option disabled value="Select Type of Membership">
//                     Select Type of Membership
//                   </option>
//                   <option>Full Membership</option>
//                   <option>Temporary Membership</option>
//                   <option>Honorary Membership</option>
//                   <option>Corporate Membership</option>
//                 </select>
//                 {formik.touched.membershipType &&
//                 formik.errors.membershipType ? (
//                   <div className="text-red-500 text-sm mt-1">
//                     {formik.errors.membershipType}
//                   </div>
//                 ) : null}
//               </div>
//             </div>
//           </section>

//           {/* Section 2: Personal Info */}
//           <section>
//             <h2 className="text-2xl font-bold mb-4 text-black">
//               Personal Information
//             </h2>
//             <div className="grid md:grid-cols-2 gap-4">
//               <div>
//                 <input
//                   type="text"
//                   name="rank"
//                   placeholder="Rank"
//                   className="p-3 rounded bg-white w-full"
//                   value={formik.values.rank}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                 />
//                 {formik.touched.rank && formik.errors.rank ? (
//                   <div className="text-red-500 text-sm mt-1">
//                     {formik.errors.rank}
//                   </div>
//                 ) : null}
//               </div>

//               <div>
//                 <input
//                   type="text"
//                   name="baNumber"
//                   placeholder="BA Number"
//                   className="p-3 rounded bg-white w-full"
//                   value={formik.values.baNumber}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                 />
//                 {formik.touched.baNumber && formik.errors.baNumber ? (
//                   <div className="text-red-500 text-sm mt-1">
//                     {formik.errors.baNumber}
//                   </div>
//                 ) : null}
//               </div>

//               {/* <div>
//                 <input
//                   type="text"
//                   name="nameEnglish"
//                   placeholder="Name"
//                   className="p-3 rounded bg-white w-full"
//                   value={formik.values.nameEnglish}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                 />
//                 {formik.touched.nameEnglish && formik.errors.nameEnglish ? (
//                   <div className="text-red-500 text-sm mt-1">
//                     {formik.errors.nameEnglish}
//                   </div>
//                 ) : null}
//               </div> */}
//               <div>
//                 <input
//                   type="text"
//                   name="firstName"
//                   placeholder="First Name"
//                   className="p-3 rounded bg-white w-full outline-none"
//                   value={formik.values.firstName}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                 />
//                 {formik.touched.firstName && formik.errors.firstName ? (
//                   <div className="text-red-500 text-sm mt-1">
//                     {formik.errors.firstName}
//                   </div>
//                 ) : null}
//               </div>

//               <div>
//                 <input
//                   type="text"
//                   name="lastName"
//                   placeholder="Last Name"
//                   className="p-3 rounded bg-white w-full outline-none"
//                   value={formik.values.lastName}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                 />
//                 {formik.touched.lastName && formik.errors.lastName ? (
//                   <div className="text-red-500 text-sm mt-1">
//                     {formik.errors.lastName}
//                   </div>
//                 ) : null}
//               </div>

//               <div>
//                 <input
//                   type="text"
//                   name="fatherOrHusbandName"
//                   placeholder="Father's/Husband's Name"
//                   className="p-3 rounded bg-white w-full"
//                   value={formik.values.fatherOrHusbandName}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                 />
//                 {formik.touched.fatherOrHusbandName &&
//                 formik.errors.fatherOrHusbandName ? (
//                   <div className="text-red-500 text-sm mt-1">
//                     {formik.errors.fatherOrHusbandName}
//                   </div>
//                 ) : null}
//               </div>

//               <div>
//                 <input
//                   type="text"
//                   name="nationality"
//                   placeholder="Nationality"
//                   className="p-3 rounded bg-white w-full"
//                   value={formik.values.nationality}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                 />
//                 {formik.touched.nationality && formik.errors.nationality ? (
//                   <div className="text-red-500 text-sm mt-1">
//                     {formik.errors.nationality}
//                   </div>
//                 ) : null}
//               </div>

//               <div>
//                 <input
//                   type="text"
//                   name="occupation"
//                   placeholder="Occupation"
//                   className="p-3 rounded bg-white w-full"
//                   value={formik.values.occupation}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                 />
//                 {formik.touched.occupation && formik.errors.occupation ? (
//                   <div className="text-red-500 text-sm mt-1">
//                     {formik.errors.occupation}
//                   </div>
//                 ) : null}
//               </div>

//               <div>
//                 <input
//                   type="text"
//                   name="bloodGroup"
//                   placeholder="Blood Group"
//                   className="p-3 rounded bg-white w-full"
//                   value={formik.values.bloodGroup}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                 />
//                 {formik.touched.bloodGroup && formik.errors.bloodGroup ? (
//                   <div className="text-red-500 text-sm mt-1">
//                     {formik.errors.bloodGroup}
//                   </div>
//                 ) : null}
//               </div>

//               <div>
//                 <input
//                   type="tel"
//                   name="mobile"
//                   placeholder="Mobile Number"
//                   className="p-3 rounded bg-white w-full"
//                   value={formik.values.mobile}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                 />
//                 {formik.touched.mobile && formik.errors.mobile ? (
//                   <div className="text-red-500 text-sm mt-1">
//                     {formik.errors.mobile}
//                   </div>
//                 ) : null}
//               </div>
//             </div>

//             <div className="mt-4">
//               <textarea
//                 name="officialAddress"
//                 placeholder="Official Address"
//                 className="p-3 rounded bg-white w-full"
//                 value={formik.values.officialAddress}
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//               />
//               {formik.touched.officialAddress &&
//               formik.errors.officialAddress ? (
//                 <div className="text-red-500 text-sm mt-1">
//                   {formik.errors.officialAddress}
//                 </div>
//               ) : null}
//             </div>

//             <div className="mt-4">
//               <textarea
//                 name="presentAddress"
//                 placeholder="Present Address"
//                 className="p-3 rounded bg-white w-full"
//                 value={formik.values.presentAddress}
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//               />
//               {formik.touched.presentAddress && formik.errors.presentAddress ? (
//                 <div className="text-red-500 text-sm mt-1">
//                   {formik.errors.presentAddress}
//                 </div>
//               ) : null}
//             </div>

//             <div className="mt-4">
//               <textarea
//                 name="permanentAddress"
//                 placeholder="Permanent Address"
//                 className="p-3 rounded bg-white w-full"
//                 value={formik.values.permanentAddress}
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//               />
//               {formik.touched.permanentAddress &&
//               formik.errors.permanentAddress ? (
//                 <div className="text-red-500 text-sm mt-1">
//                   {formik.errors.permanentAddress}
//                 </div>
//               ) : null}
//             </div>
//           </section>

//           {/* Section 3: Income */}
//           <section>
//             <h2 className="text-2xl font-bold mb-4 text-black">
//               Income & Tax Details
//             </h2>
//             <div>
//               <input
//                 type="text"
//                 name="monthlyIncome"
//                 placeholder="Monthly Income"
//                 className="p-3 rounded bg-white w-full mb-4"
//                 value={formik.values.monthlyIncome}
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//               />
//               {formik.touched.monthlyIncome && formik.errors.monthlyIncome ? (
//                 <div className="text-red-500 text-sm mt-1">
//                   {formik.errors.monthlyIncome}
//                 </div>
//               ) : null}
//             </div>
//             <label className="block mb-2 font-semibold text-black">
//               Upload Income Tax Return (image)
//             </label>
//             <input
//               type="file"
//               accept="image/*"
//               name="incomeTaxReturn"
//               className="block w-full bg-white p-2 rounded"
//               onChange={handleFileChange("incomeTaxReturn")}
//               onBlur={formik.handleBlur}
//             />
//             {formik.touched.incomeTaxReturn && formik.errors.incomeTaxReturn ? (
//               <div className="text-red-500 text-sm mt-1">
//                 {formik.errors.incomeTaxReturn}
//               </div>
//             ) : null}
//           </section>

//           <section>
//             <h2 className="text-2xl font-bold mb-4 text-black">
//               Identity Documents
//             </h2>
//             <>
//               <div className="mb-6">
//                 <h3 className="text-lg font-semibold mb-3">
//                   National ID Details (Required)
//                 </h3>
//                 <div className="grid md:grid-cols-2 gap-4">
//                   <div>
//                     <input
//                       type="text"
//                       name="nationalId"
//                       placeholder="National ID Number"
//                       className="p-3 rounded bg-white w-full"
//                       value={formik.values.nationalId}
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                     />
//                     {formik.touched.nationalId && formik.errors.nationalId ? (
//                       <div className="text-red-500 text-sm mt-1">
//                         {formik.errors.nationalId}
//                       </div>
//                     ) : null}
//                   </div>

//                   <div>
//                     <input
//                       type="text"
//                       name="nidName"
//                       placeholder="Name as in NID"
//                       className="p-3 rounded bg-white w-full"
//                       value={formik.values.nidName}
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                     />
//                     {formik.touched.nidName && formik.errors.nidName ? (
//                       <div className="text-red-500 text-sm mt-1">
//                         {formik.errors.nidName}
//                       </div>
//                     ) : null}
//                   </div>

//                   <div>
//                     <input
//                       type="text"
//                       name="nidFathersName"
//                       placeholder="Father's Name (from NID)"
//                       className="p-3 rounded bg-white w-full"
//                       value={formik.values.nidFathersName}
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                     />
//                     {formik.touched.nidFathersName &&
//                     formik.errors.nidFathersName ? (
//                       <div className="text-red-500 text-sm mt-1">
//                         {formik.errors.nidFathersName}
//                       </div>
//                     ) : null}
//                   </div>

//                   <div>
//                     <input
//                       type="text"
//                       name="nidMothersName"
//                       placeholder="Mother's Name (from NID)"
//                       className="p-3 rounded bg-white w-full"
//                       value={formik.values.nidMothersName}
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                     />
//                     {formik.touched.nidMothersName &&
//                     formik.errors.nidMothersName ? (
//                       <div className="text-red-500 text-sm mt-1">
//                         {formik.errors.nidMothersName}
//                       </div>
//                     ) : null}
//                   </div>

//                   <div>
//                     <label className="text-gray-400 pl-2" htmlFor="">
//                       Date Of Birth
//                     </label>
//                     <input
//                       type="date"
//                       name="nidDob"
//                       placeholder="Date of Birth (from NID)"
//                       className="p-3 rounded bg-white w-full"
//                       value={formik.values.nidDob}
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                     />
//                     {formik.touched.nidDob && formik.errors.nidDob ? (
//                       <div className="text-red-500 text-sm mt-1">
//                         {formik.errors.nidDob}
//                       </div>
//                     ) : null}
//                   </div>

//                   <div>
//                     <label className="block mb-2 font-semibold text-black">
//                       Upload NID (image)
//                     </label>
//                     <input
//                       type="file"
//                       accept="image/*"
//                       name="nidCopy"
//                       className="block w-full bg-white p-2 rounded"
//                       onChange={handleFileChange("nidCopy")}
//                       onBlur={formik.handleBlur}
//                     />
//                     {formik.touched.nidCopy && formik.errors.nidCopy ? (
//                       <div className="text-red-500 text-sm mt-1">
//                         {formik.errors.nidCopy}
//                       </div>
//                     ) : null}
//                   </div>
//                 </div>
//               </div>

//               {/* <div className="mt-6">
//                   <h3 className="text-lg font-semibold mb-3">
//                     Passport Details (Optional)
//                   </h3>
//                   <div className="grid md:grid-cols-2 gap-4">
//                     <div>
//                       <input
//                         type="text"
//                         name="passportNumber"
//                         placeholder="Passport Number"
//                         className="p-3 rounded bg-white w-full"
//                         value={formik.values.passportNumber}
//                         onChange={formik.handleChange}
//                         onBlur={formik.handleBlur}
//                       />
//                       {formik.touched.passportNumber &&
//                       formik.errors.passportNumber ? (
//                         <div className="text-red-500 text-sm mt-1">
//                           {formik.errors.passportNumber}
//                         </div>
//                       ) : null}
//                     </div>

//                     <div>
//                       <input
//                         type="text"
//                         name="passportType"
//                         placeholder="Passport Type"
//                         className="p-3 rounded bg-white w-full"
//                         value={formik.values.passportType}
//                         onChange={formik.handleChange}
//                         onBlur={formik.handleBlur}
//                       />
//                       {formik.touched.passportType &&
//                       formik.errors.passportType ? (
//                         <div className="text-red-500 text-sm mt-1">
//                           {formik.errors.passportType}
//                         </div>
//                       ) : null}
//                     </div>

//                     <div>
//                       <input
//                         type="text"
//                         name="passportPlaceOfIssue"
//                         placeholder="Place of Issue"
//                         className="p-3 rounded bg-white w-full"
//                         value={formik.values.passportPlaceOfIssue}
//                         onChange={formik.handleChange}
//                         onBlur={formik.handleBlur}
//                       />
//                       {formik.touched.passportPlaceOfIssue &&
//                       formik.errors.passportPlaceOfIssue ? (
//                         <div className="text-red-500 text-sm mt-1">
//                           {formik.errors.passportPlaceOfIssue}
//                         </div>
//                       ) : null}
//                     </div>

//                     <div>
//                       <label className="text-gray-400 pl-2" htmlFor="">
//                         Date Of Expiry
//                       </label>
//                       <input
//                         type="date"
//                         name="passportExpiry"
//                         placeholder="Date of Expiry"
//                         className="p-3 rounded bg-white w-full"
//                         value={formik.values.passportExpiry}
//                         onChange={formik.handleChange}
//                         onBlur={formik.handleBlur}
//                       />
//                       {formik.touched.passportExpiry &&
//                       formik.errors.passportExpiry ? (
//                         <div className="text-red-500 text-sm mt-1">
//                           {formik.errors.passportExpiry}
//                         </div>
//                       ) : null}
//                     </div>
//                   </div>
//                 </div> */}
//             </>
//           </section>

//           {/* Section 5: Family */}
//           <section>
//             <h2 className="text-2xl font-bold mb-4 text-black">
//               Family Details
//             </h2>
//             <h4 className="text-lg font-semibold text-black mt-4 mb-2">
//               Spouse (if any)
//             </h4>
//             <div>
//               <input
//                 type="text"
//                 name="spouseName"
//                 placeholder="Spouse Name"
//                 className="p-3 rounded bg-white w-full mb-4"
//                 value={formik.values.spouseName}
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//               />
//               {formik.touched.spouseName && formik.errors.spouseName ? (
//                 <div className="text-red-500 text-sm mt-1">
//                   {formik.errors.spouseName}
//                 </div>
//               ) : null}
//             </div>

//             <div>
//               <input
//                 type="text"
//                 name="spouseOccupation"
//                 placeholder="Spouse Occupation"
//                 className="p-3 rounded bg-white w-full mb-4"
//                 value={formik.values.spouseOccupation}
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//               />
//               {formik.touched.spouseOccupation &&
//               formik.errors.spouseOccupation ? (
//                 <div className="text-red-500 text-sm mt-1">
//                   {formik.errors.spouseOccupation}
//                 </div>
//               ) : null}
//             </div>

//             <div>
//               <input
//                 type="text"
//                 name="spouseAddress"
//                 placeholder="Spouse Address"
//                 className="p-3 rounded bg-white w-full mb-4"
//                 value={formik.values.spouseAddress}
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//               />
//               {formik.touched.spouseAddress && formik.errors.spouseAddress ? (
//                 <div className="text-red-500 text-sm mt-1">
//                   {formik.errors.spouseAddress}
//                 </div>
//               ) : null}
//             </div>

//             <h4 className="text-lg font-semibold text-black mt-4 mb-2">
//               Children/Dependants below 21 (if any)
//             </h4>
//             {formik.values.children &&
//               formik.values.children.length > 0 &&
//               formik.values.children.map((child, i) => (
//                 <div
//                   key={i}
//                   className="grid grid-cols-2 lg:grid-cols-2 gap-3 mb-2 items-center"
//                 >
//                   <div className="pt-6">
//                     <input
//                       type="text"
//                       placeholder="Name"
//                       className="p-2 rounded bg-white w-full"
//                       value={child.name}
//                       onChange={(e) => {
//                         const updatedChildren = [...formik.values.children];
//                         updatedChildren[i].name = e.target.value;
//                         formik.setFieldValue("children", updatedChildren);
//                       }}
//                       onBlur={formik.handleBlur}
//                     />
//                     {formik.touched.children?.[i]?.name &&
//                     formik.errors.children?.[i]?.name ? (
//                       <div className="text-red-500 text-sm mt-1">
//                         {formik.errors.children[i].name}
//                       </div>
//                     ) : null}
//                   </div>

//                   <div>
//                     <label className="text-gray-400 pl-2" htmlFor="">
//                       Date Of Birth
//                     </label>
//                     <input
//                       type="date"
//                       placeholder="Date of Birth"
//                       className="p-2 rounded bg-white w-full"
//                       value={child.dob}
//                       onChange={(e) => {
//                         const updatedChildren = [...formik.values.children];
//                         updatedChildren[i].dob = e.target.value;
//                         formik.setFieldValue("children", updatedChildren);
//                       }}
//                       onBlur={formik.handleBlur}
//                     />
//                     {formik.touched.children?.[i]?.dob &&
//                     formik.errors.children?.[i]?.dob ? (
//                       <div className="text-red-500 text-sm mt-1">
//                         {formik.errors.children[i].dob}
//                       </div>
//                     ) : null}
//                   </div>

//                   <div className="pt-6">
//                     <input
//                       type="text"
//                       placeholder="Relationship"
//                       className="p-2 rounded bg-white w-full"
//                       value={child.gender}
//                       onChange={(e) => {
//                         const updatedChildren = [...formik.values.children];
//                         updatedChildren[i].gender = e.target.value;
//                         formik.setFieldValue("children", updatedChildren);
//                       }}
//                       onBlur={formik.handleBlur}
//                     />
//                     {formik.touched.children?.[i]?.gender &&
//                     formik.errors.children?.[i]?.gender ? (
//                       <div className="text-red-500 text-sm mt-1">
//                         {formik.errors.children[i].gender}
//                       </div>
//                     ) : null}
//                   </div>

//                   <div className="">
//                     {/* <label className="text-gray-400 pl-2" htmlFor="">
//                         Honorary?
//                       </label>
//                       <select
//                         className="p-2 rounded bg-white w-full"
//                         value={child.honorary ? "Yes" : "No"}
//                         onChange={(e) => {
//                           const updatedChildren = [...formik.values.children];
//                           updatedChildren[i].honorary = e.target.value === "Yes";
//                           formik.setFieldValue("children", updatedChildren);
//                         }}
//                         onBlur={formik.handleBlur}
//                       >
//                         <option>Yes</option>
//                         <option>No</option>
//                       </select> */}
//                     {/* {formik.touched.children?.[i]?.honorary &&
//                     formik.errors.children?.[i]?.honorary ? (
//                       <div className="text-red-500 text-sm mt-1">
//                         {formik.errors.children[i].honorary}
//                       </div>
//                     ) : null} */}

//                     {/* Delete button */}
//                     {formik.values.children.length > 1 && (
//                       <button
//                         type="button"
//                         onClick={() => removeChild(i)}
//                         className="text-red-500 text-md"
//                         title="Remove Child"
//                       >
//                         ✖
//                       </button>
//                     )}
//                   </div>
//                 </div>
//               ))}
//             <button
//               type="button"
//               onClick={addChild}
//               className="text-sm text-green-600 underline mt-2"
//             >
//               + Add {formik.values.children.length >= 1 && "Another"} Child
//             </button>
//           </section>

//           {/* Section 6: Other Details */}
//           <section>
//             <h2 className="text-2xl font-bold mb-4 text-black">
//               Golf Club Details (Optional)
//             </h2>
//             <div>
//               <input
//                 type="text"
//                 name="golfClubMembership"
//                 placeholder="Membership of any Golf Club (if any)"
//                 className="p-3 rounded bg-white w-full mb-4"
//                 value={formik.values.golfClubMembership}
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//               />
//               {formik.touched.golfClubMembership &&
//               formik.errors.golfClubMembership ? (
//                 <div className="text-red-500 text-sm mt-1">
//                   {formik.errors.golfClubMembership}
//                 </div>
//               ) : null}
//             </div>

//             <div>
//               <input
//                 type="text"
//                 name="officialHandicap"
//                 placeholder="Official Handicap (if any)"
//                 className="p-3 rounded bg-white w-full"
//                 value={formik.values.officialHandicap}
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//               />
//               {formik.touched.officialHandicap &&
//               formik.errors.officialHandicap ? (
//                 <div className="text-red-500 text-sm mt-1">
//                   {formik.errors.officialHandicap}
//                 </div>
//               ) : null}
//             </div>
//           </section>

//           {/* Section 7: File Uploads */}
//           <section>
//             <h2 className="text-2xl font-bold mb-4 text-black">Photos</h2>
//             <label className="block mb-2">
//               Upload Your Photo (passport size)
//             </label>
//             <input
//               type="file"
//               name="photo"
//               accept="image/*"
//               // multiple
//               className="mb-4 block w-full bg-white p-2 rounded"
//               // onChange={handleMultipleFilesChange("photo")}
//               onChange={handleFileChange("photo")}
//               onBlur={formik.handleBlur}
//             />
//             {formik.touched.photo && formik.errors.photo ? (
//               <div className="text-red-500 text-sm mt-1">
//                 {formik.errors.photo}
//               </div>
//             ) : null}

//             {/* <label className="block mb-2">
//               Upload NID, Passport, TIN, Employer Certificate, Tax Certificate
//               (image files)
//             </label>
//             <input
//               type="file"
//               accept="image/*"
//               name="documents"
//               multiple
//               className="block w-full bg-white p-2 rounded"
//               onChange={handleMultipleFilesChange("documents")}
//               onBlur={formik.handleBlur}
//             />
//             {formik.touched.documents && formik.errors.documents ? (
//               <div className="text-red-500 text-sm mt-1">
//                 {formik.errors.documents}
//               </div>
//             ) : null} */}
//           </section>

//           {/* Section 9: Account Registration */}
//           <section>
//             <h2 className="text-2xl font-bold mb-4 text-black">
//               Create Your Account
//             </h2>
//             <div className="grid md:grid-cols-2 gap-4">
//               <div>
//                 <input
//                   type="email"
//                   name="email"
//                   placeholder="Email Address"
//                   className="p-3 rounded bg-white w-full outline-none"
//                   value={formik.values.email}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                 />
//                 {formik.touched.email && formik.errors.email ? (
//                   <div className="text-red-500 text-sm mt-1">
//                     {formik.errors.email}
//                   </div>
//                 ) : null}
//               </div>
//             </div>
//           </section>

//           {/* Submit */}
//           <div>
//             {/* <button
//               type="submit"
//               className="bg-lime-400 hover:bg-black hover:text-white w-full py-3 rounded-full font-bold text-black transition"
//               disabled={formik.isSubmitting}
//             >
//               {formik.isSubmitting ? "Submitting..." : "Submit Registration"}
//             </button> */}
//             {/* <button
//               type="submit"
//               className="bg-lime-400 hover:bg-black hover:text-white w-full py-3 rounded-full font-bold text-black transition"
//               disabled={formik.isSubmitting}
//             >
//               {formik.isSubmitting ? (
//                 <span className="flex items-center justify-center">
//                   <svg
//                     className="animate-spin -ml-1 mr-3 h-5 w-5 text-black"
//                     xmlns="http://www.w3.org/2000/svg"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                   >
//                     <circle
//                       className="opacity-25"
//                       cx="12"
//                       cy="12"
//                       r="10"
//                       stroke="currentColor"
//                       strokeWidth="4"
//                     ></circle>
//                     <path
//                       className="opacity-75"
//                       fill="currentColor"
//                       d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
//                     ></path>
//                   </svg>
//                   Processing...
//                 </span>
//               ) : (
//                 "REGISTER"
//               )}
//             </button> */}
//             <button
//               type="submit"
//               className="bg-lime-400 hover:bg-black hover:text-white w-full py-3 rounded-full font-bold text-black transition"
//               disabled={formik.isSubmitting || isSendingOtp}
//             >
//               {formik.isSubmitting || isSendingOtp ? (
//                 <span className="flex items-center justify-center">
//                   <svg
//                     className="animate-spin -ml-1 mr-3 h-5 w-5 text-black"
//                     xmlns="http://www.w3.org/2000/svg"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                   >
//                     <circle
//                       className="opacity-25"
//                       cx="12"
//                       cy="12"
//                       r="10"
//                       stroke="currentColor"
//                       strokeWidth="4"
//                     ></circle>
//                     <path
//                       className="opacity-75"
//                       fill="currentColor"
//                       d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
//                     ></path>
//                   </svg>
//                   {isSendingOtp ? "Sending Code..." : "Processing..."}
//                 </span>
//               ) : (
//                 "SEND VERIFICATION CODE"
//               )}
//             </button>
//           </div>
//         </div>
//       </form>
//     </div>
//   );
// };

// export default DefenceOfficer;

import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import api from "../api/axiosInstance";
import { uploadToCloudinary } from "../utils/cloudinaryUpload";
import { useEffect, useState, useRef } from "react";

const DefenceOfficer = ({ category, categoryEnum }) => {
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otp, setOtp] = useState("");
  const [isVerifying, setIsVerifying] = useState(false);
  const [isSendingOtp, setIsSendingOtp] = useState(false);
  const [formData, setFormData] = useState(null);
  const [cooldownSeconds, setCooldownSeconds] = useState(0);
  const [cooldownInterval, setCooldownInterval] = useState(null);

  // Create ref for OTP modal
  const otpModalRef = useRef(null);

  // Form validation schema
  const validationSchema = Yup.object().shape({
    membershipType: Yup.string()
      .required("Membership type is required")
      .notOneOf(["Select Type of Membership"], "Membership type is required"),
    rank: Yup.string().required("Rank is required"),
    baNumber: Yup.string().required("BA Number is required"),
    firstName: Yup.string().required("First Name is required"),
    lastName: Yup.string().required("Last Name is required"),
    gender: Yup.string().required("Gender is required"),
    // fatherOrHusbandName: Yup.string().required(
    //   "Father's / Husband's Name is required"
    // ),
    nationality: Yup.string().required("Nationality is required"),
    occupation: Yup.string().required("Occupation is required"),
    bloodGroup: Yup.string().required("Blood Group is required"),
    mobile: Yup.string()
      .required("Mobile number is required")
      .matches(/^[0-9]+$/, "Must be only digits")
      .min(11, "Must be at least 11 digits"),
    officialAddress: Yup.string().required("Official Address is required"),
    presentAddress: Yup.string().required("Present Address is required"),
    permanentAddress: Yup.string().required("Permanent Address is required"),
    monthlyIncome: Yup.number().required("Monthly Income is required"),
    incomeTaxReturn: Yup.string().required("Tax return document is required"),

    nationalId: Yup.string().required("National ID is required"),
    // nidName: Yup.string().required("NID Name is required"),
    // nidFathersName: Yup.string().required(
    //   "Father's Name (from NID) is required"
    // ),
    // nidMothersName: Yup.string().required(
    //   "Mother's Name (from NID) is required"
    // ),
    // nidDob: Yup.date().required("Date of Birth (from NID) is required"),
    nidCopy: Yup.string().required("NID image is required"),
    photo: Yup.string().required("Photo is required"),

    email: Yup.string().email("Invalid email").required("Email is required"),
  });

  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      membershipType: "Select Type of Membership",
      rank: "",
      baNumber: "",
      firstName: "",
      lastName: "",
      gender: "",
      // fatherOrHusbandName: "",
      nationality: "",
      occupation: "",
      bloodGroup: "",
      mobile: "",
      officialAddress: "",
      presentAddress: "",
      permanentAddress: "",
      monthlyIncome: "",
      incomeTaxReturn: "",
      nationalId: "",
      // nidName: "",
      // nidFathersName: "",
      // nidMothersName: "",
      // nidDob: "",
      nidCopy: "",
      spouseName: "",
      spouseOccupation: "",
      spouseAddress: "",
      children: [],
      golfClubMembership: "",
      // officialHandicap: "",
      photo: "",
      email: "",
    },
    validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      console.log("Form submission started");
      console.log("Form values:", values);
      try {
        setSubmitting(true);

        // First check if we can send OTP (cooldown and existing registration)
        try {
          const cooldownResponse = await api.get("/verification/cooldown", {
            params: { email: values.email },
          });

          if (!cooldownResponse.data.canSendOtp) {
            const seconds = cooldownResponse.data.cooldownSeconds;
            setCooldownSeconds(seconds);
            startCooldownTimer(seconds);
            toast.error(
              `Please wait ${seconds} seconds before requesting another code`
            );
            return;
          }
        } catch (cooldownError) {
          console.log(
            "Cooldown check failed, proceeding anyway:",
            cooldownError
          );
        }

        // Store form data for later submission
        setFormData(values);

        // Send OTP to email
        setIsSendingOtp(true);
        await api.post("/verification/send-otp", null, {
          params: { email: values.email },
        });

        toast.success("Verification code sent to your email");
        setShowOtpModal(true);

        // Scroll to OTP modal after showing it
        setTimeout(() => {
          if (otpModalRef.current) {
            otpModalRef.current.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }
        }, 100);
      } catch (error) {
        console.error("Error sending OTP:", error);
        console.error("Full error object:", error);
        console.error("Error response:", error.response);

        // Enhanced error handling
        if (error.response?.data) {
          const errorMessage = error.response.data;

          if (typeof errorMessage === "string") {
            if (errorMessage.includes("EMAIL_ALREADY_REGISTERED")) {
              toast.error(
                "Email already registered. Please use a different email or login."
              );
            } else if (errorMessage.includes("OTP_COOLDOWN_ACTIVE")) {
              toast.error(
                "Please wait before requesting another verification code."
              );
            } else {
              toast.error(errorMessage);
            }
          } else if (errorMessage.message) {
            toast.error(errorMessage.message);
          }
        } else if (error.response?.status === 409) {
          toast.error(
            "Email already registered. Please use a different email."
          );
        } else if (error.response?.status === 400) {
          toast.error(
            "Please wait before requesting another verification code."
          );
        } else if (error.message) {
          if (error.message.includes("EMAIL_ALREADY_REGISTERED")) {
            toast.error(
              "Email already registered. Please use a different email."
            );
          } else if (error.message.includes("OTP_COOLDOWN_ACTIVE")) {
            toast.error(
              "Please wait before requesting another verification code."
            );
          } else {
            toast.error(error.message);
          }
        } else {
          toast.error("Failed to send verification code. Please try again.");
        }
      } finally {
        setSubmitting(false);
        setIsSendingOtp(false);
      }
    },
  });

  const handleOtpVerification = async () => {
    if (!otp || otp.length !== 6) {
      toast.error("Please enter a valid 6-digit code");
      return;
    }

    try {
      setIsVerifying(true);
      await api.post("/verification/verify-otp", null, {
        params: {
          email: formData.email,
          code: otp,
        },
      });

      toast.success("Email verified successfully!");

      // Now submit the registration with verified email
      const filteredChildren = formData.children.filter(
        (child) => child.name.trim() !== ""
      );

      const submissionData = {
        ...formData,
        category: category,
        gender: formData.gender,
        children: filteredChildren.length > 0 ? filteredChildren : undefined,
      };

      const response = await api.post(
        "/registration/membership",
        submissionData,
        {
          params: { emailVerificationToken: otp },
        }
      );

      if (response.status === 201) {
        toast.success("Registration submitted successfully!");
        navigate("/email-verified");
      }
    } catch (error) {
      console.error("Verification error:", error);
      toast.error(
        error.response?.data?.message ||
          "Verification failed. Please try again."
      );
    } finally {
      setIsVerifying(false);
    }
  };

  const handleResendOtp = async () => {
    try {
      // Check cooldown first
      if (cooldownSeconds > 0) {
        toast.error(
          `Please wait ${cooldownSeconds} seconds before requesting another code`
        );
        return;
      }

      setIsSendingOtp(true);
      await api.post("/verification/send-otp", null, {
        params: { email: formData.email },
      });

      // Start cooldown timer (60 seconds)
      startCooldownTimer(60);
      toast.success("New verification code sent!");
    } catch (error) {
      console.error("Error resending OTP:", error);

      if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Failed to resend code. Please try again.");
      }
    } finally {
      setIsSendingOtp(false);
    }
  };

  // Helper functions for children fields
  const addChild = () => {
    if (
      formik.values.children.length === 0 ||
      formik.values.children[formik.values.children.length - 1].name.trim() !==
        ""
    ) {
      formik.setFieldValue("children", [
        ...formik.values.children,
        { name: "", dob: "", gender: "" },
      ]);
    }
  };

  const removeChild = (index) => {
    const updated = [...formik.values.children];
    updated.splice(index, 1);
    formik.setFieldValue("children", updated.length > 0 ? updated : undefined);
  };

  // Cooldown timer functions
  const startCooldownTimer = (seconds) => {
    // Clear any interval already running before starting a new one, otherwise
    // resubmitting mid-cooldown stacks intervals and the countdown races ahead.
    if (cooldownInterval) {
      clearInterval(cooldownInterval);
    }
    setCooldownSeconds(seconds);

    const interval = setInterval(() => {
      setCooldownSeconds((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    setCooldownInterval(interval);
  };

  const clearCooldownTimer = () => {
    if (cooldownInterval) {
      clearInterval(cooldownInterval);
      setCooldownInterval(null);
    }
    setCooldownSeconds(0);
  };

  // Clean up interval on component unmount
  useEffect(() => {
    return () => {
      if (cooldownInterval) {
        clearInterval(cooldownInterval);
      }
    };
  }, [cooldownInterval]);

  // Max file size in bytes (5 MB)
  const MAX_FILE_SIZE = 5 * 1024 * 1024;

  const handleFileChange = (fieldName) => async (event) => {
    const file = event.currentTarget.files[0];
    if (file) {
      if (!file.type.startsWith("image/")) {
        toast.error("Only image files are allowed");
        formik.setFieldError(fieldName, "Only image files are allowed");
        return;
      }

      if (file.size > MAX_FILE_SIZE) {
        toast.error(`File size must not exceed 5MB`);
        formik.setFieldError(fieldName, "File size must not exceed 5MB");
        return;
      }
      const url = await uploadToCloudinary(file);
      formik.setFieldValue(fieldName, url);
    }
  };

  return (
    <div className="bg-gradient-to-b from-[#fffdf7] to-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <form onSubmit={formik.handleSubmit}>
        {/* OTP Modal */}
        {showOtpModal && (
          <div
            ref={otpModalRef}
            className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4"
          >
            <div className="bg-gradient-to-br from-white via-emerald-50/50 to-lime-50/50 rounded-3xl shadow-2xl p-6 md:p-10 max-w-md w-full transform transition-all duration-500 scale-100 border-2 border-emerald-100 overflow-hidden">
              {/* Top decorative accent */}
              <div className="absolute top-0 left-0 right-0 h-2 bg-gradient-to-r from-emerald-400 via-lime-400 to-emerald-400"></div>

              {/* Decorative corner elements */}
              <div className="absolute -top-12 -right-12 w-24 h-24 bg-gradient-to-br from-emerald-200/20 to-lime-200/20 rounded-full blur-xl"></div>
              <div className="absolute -bottom-12 -left-12 w-24 h-24 bg-gradient-to-br from-lime-200/20 to-emerald-200/20 rounded-full blur-xl"></div>

              <div className="relative">
                {/* Header */}
                <div className="text-center mb-8">
                  <div className="relative inline-flex mb-6">
                    <div className="absolute inset-0 bg-gradient-to-r from-emerald-400 to-lime-400 rounded-full blur-lg opacity-40"></div>
                    <div className="relative w-20 h-20 rounded-full bg-gradient-to-br from-emerald-50 to-lime-50 border-2 border-emerald-100 flex items-center justify-center shadow-lg">
                      <svg
                        className="w-10 h-10 text-emerald-600"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                      </svg>
                    </div>
                  </div>
                  <h3 className="text-3xl font-bold text-gray-900 mb-3">
                    Verify Your Account
                  </h3>
                  <p className="text-gray-600 mb-2">
                    Enter the 6-digit verification code sent to
                  </p>
                  <p className="text-lg font-semibold text-emerald-700 bg-gradient-to-r from-emerald-50 to-lime-50 py-2 px-4 rounded-xl inline-block">
                    {formData?.email}
                  </p>
                </div>

                {/* OTP Input Grid */}
                <div className="mb-10">
                  <div className="grid grid-cols-6 gap-3 mb-4">
                    {[...Array(6)].map((_, index) => (
                      <div key={index} className="relative group">
                        <input
                          type="text"
                          maxLength={1}
                          className={`
                  w-full h-16 text-center text-4xl font-bold 
                  bg-gradient-to-b from-white to-gray-50 
                  border-2 rounded-xl 
                  focus:outline-none focus:shadow-lg
                  transition-all duration-300
                  ${
                    otp[index]
                      ? "border-emerald-400 shadow-emerald-200/50 shadow-lg"
                      : "border-gray-200 group-hover:border-emerald-300"
                  }
                `}
                          value={otp[index] || ""}
                          onChange={(e) => {
                            const value = e.target.value.replace(/[^0-9]/g, "");
                            if (value) {
                              const newOtp = otp.split("");
                              newOtp[index] = value;
                              const updatedOtp = newOtp.join("");
                              setOtp(updatedOtp);

                              if (index < 5) {
                                document
                                  .getElementById(`otp-${index + 1}`)
                                  .focus();
                              }
                            } else {
                              const newOtp = otp.split("");
                              newOtp[index] = "";
                              setOtp(newOtp.join(""));
                            }
                          }}
                          onKeyDown={(e) => {
                            if (
                              e.key === "Backspace" &&
                              !otp[index] &&
                              index > 0
                            ) {
                              document
                                .getElementById(`otp-${index - 1}`)
                                .focus();
                            }
                          }}
                          id={`otp-${index}`}
                        />
                        {/* Bottom indicator */}
                        <div
                          className={`
                absolute -bottom-1 left-1/2 transform -translate-x-1/2 
                w-8 h-1 rounded-full transition-all duration-300
                ${
                  otp[index]
                    ? "bg-gradient-to-r from-emerald-400 to-lime-400"
                    : "bg-gray-200 group-hover:bg-emerald-300"
                }
              `}
                        ></div>
                      </div>
                    ))}
                  </div>

                  {/* Progress indicator */}
                  <div className="flex items-center justify-center gap-2">
                    <div className="text-sm text-gray-500">
                      {otp.length}/6 digits entered
                    </div>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="flex flex-col sm:flex-row gap-4 mb-8">
                  <button
                    type="button"
                    onClick={() => {
                      setShowOtpModal(false);
                      setOtp("");
                      clearCooldownTimer();
                    }}
                    className="flex-1 group bg-gradient-to-b from-gray-50 to-gray-100 hover:from-gray-100 hover:to-gray-200 text-gray-800 py-4 rounded-xl font-semibold transition-all duration-300 shadow-lg hover:shadow-xl border border-gray-200"
                    disabled={isVerifying}
                  >
                    <div className="flex items-center justify-center gap-2">
                      <svg
                        className="w-5 h-5 group-hover:-translate-x-1 transition-transform"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
                      </svg>
                      Cancel
                    </div>
                  </button>
                  <button
                    type="button"
                    onClick={handleOtpVerification}
                    className="flex-1 group bg-gradient-to-r from-emerald-500 to-lime-500 hover:from-emerald-600 hover:to-lime-600 text-white py-4 rounded-xl font-semibold shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-0.5 disabled:opacity-50 disabled:cursor-not-allowed"
                    disabled={isVerifying || otp.length !== 6}
                  >
                    <div className="absolute inset-0 rounded-xl bg-gradient-to-r from-emerald-400 to-lime-400 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                    <span className="relative flex items-center justify-center gap-2">
                      {isVerifying ? (
                        <>
                          <svg
                            className="animate-spin h-5 w-5 text-white"
                            fill="none"
                            viewBox="0 0 24 24"
                          >
                            <circle
                              className="opacity-25"
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="currentColor"
                              strokeWidth="4"
                            ></circle>
                            <path
                              className="opacity-75"
                              fill="currentColor"
                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            ></path>
                          </svg>
                          Verifying...
                        </>
                      ) : (
                        <>
                          Complete Registration
                          <svg
                            className="w-5 h-5 group-hover:translate-x-1 transition-transform"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                          </svg>
                        </>
                      )}
                    </span>
                  </button>
                </div>

                {/* Resend Code Section */}
                <div className="text-center pt-6 border-t border-gray-100">
                  <p className="text-sm text-gray-500 mb-4">
                    Didn't receive the code?{" "}
                    {cooldownSeconds > 0 && (
                      <span className="font-medium text-emerald-600">
                        Resend available in {cooldownSeconds}s
                      </span>
                    )}
                  </p>
                  <button
                    type="button"
                    onClick={handleResendOtp}
                    className={`
            inline-flex items-center gap-2 px-6 py-3 rounded-xl font-medium 
            transition-all duration-300 transform hover:-translate-y-0.5
            ${
              cooldownSeconds > 0 || isSendingOtp
                ? "text-gray-400 bg-gray-100 cursor-not-allowed"
                : "text-emerald-600 hover:text-emerald-800 hover:bg-emerald-50 shadow-sm hover:shadow-md"
            }
          `}
                    disabled={isSendingOtp || cooldownSeconds > 0}
                  >
                    {isSendingOtp ? (
                      <>
                        <svg
                          className="animate-spin h-5 w-5"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          ></circle>
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          ></path>
                        </svg>
                        Sending New Code...
                      </>
                    ) : cooldownSeconds > 0 ? (
                      <>
                        <svg
                          className="w-5 h-5"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z" />
                        </svg>
                        Wait {cooldownSeconds} seconds
                      </>
                    ) : (
                      <>
                        <svg
                          className="w-5 h-5"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z" />
                        </svg>
                        Resend Verification Code
                      </>
                    )}
                  </button>
                </div>

                {/* Security Note */}
                <div className="mt-6 pt-4 border-t border-gray-100">
                  <div className="flex items-start gap-3">
                    <svg
                      className="w-5 h-5 text-emerald-500 mt-0.5 flex-shrink-0"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z" />
                    </svg>
                    <p className="text-xs text-gray-500">
                      For security purposes, this code will expire in 10
                      minutes. Keep it confidential.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Main Form */}
        <div className="max-w-6xl mx-auto bg-white rounded-2xl shadow-lg p-6 md:p-8 lg:p-10 space-y-12">
          {/* Section 1: Category & Type */}
          {/* <section className="bg-gradient-to-r from-gray-50 to-white p-6 rounded-xl border border-gray-100">
            <div className="flex items-center mb-6">
              <div className="w-2 h-8 bg-lime-500 rounded-full mr-3"></div>
              <h2 className="text-2xl font-bold text-gray-900">
                Membership Category & Type
              </h2>
            </div>
            <div className="grid md:grid-cols-2 gap-4">
              <div>
                <div className="relative">
                  <select
                    className="p-4 bg-gray-50 rounded-xl w-full outline-none border border-gray-200 focus:border-lime-500 focus:ring-2 focus:ring-lime-200 transition duration-200 appearance-none"
                    name="membershipType"
                    value={formik.values.membershipType}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  >
                    <option disabled value="Select Type of Membership">
                      Select Type of Membership
                    </option>
                    <option>Full Membership</option>
                    <option>Temporary Membership</option>
                    <option>Honorary Membership</option>
                    <option>Corporate Membership</option>
                  </select>
                  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-3 text-gray-400">
                    <svg
                      className="w-5 h-5"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                </div>
                {formik.touched.membershipType &&
                formik.errors.membershipType ? (
                  <div className="text-red-500 text-sm mt-2 pl-2">
                    {formik.errors.membershipType}
                  </div>
                ) : null}
              </div>
            </div>
          </section> */}
          <section className="bg-gradient-to-r from-gray-50 to-white p-6 rounded-xl border border-gray-100">
            <div className="flex items-center mb-6">
              <div className="w-2 h-8 bg-lime-500 rounded-full mr-3"></div>
              <h2 className="text-2xl font-bold text-gray-900">
                Membership Type
              </h2>
            </div>

            {/* Category Display (read-only) */}
            {/* <div className="mb-6">
              <label className="block text-gray-700 font-medium mb-2">
                Selected Category
              </label>
              <div className="p-4 bg-gray-50 rounded-xl border border-gray-200">
                <span className="text-lg font-semibold text-gray-900">
                  {category}
                </span>
              </div>
            </div> */}

            {/* Membership Type Dropdown - UPDATED */}
            <div>
              <label className="block text-gray-700 font-medium mb-2">
                Membership Type *
              </label>
              <div className="relative">
                <select
                  className="p-4 bg-gray-50 rounded-xl w-full outline-none border border-gray-200 focus:border-lime-500 focus:ring-2 focus:ring-lime-200 transition duration-200 appearance-none"
                  name="membershipType"
                  value={formik.values.membershipType}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  <option disabled value="Select Type of Membership">
                    Select Type of Membership
                  </option>
                  <option value="Full Members">Full Members</option>
                  <option value="Sleeping Members">Sleeping Members</option>
                  {/* For CORPORATE_MEMBERS - only show for corporate category */}
                  {categoryEnum === "Non-government Organization/Agency" && (
                    <option value="Corporate Members">Corporate Members</option>
                  )}
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-3 text-gray-400">
                  <svg
                    className="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
              </div>
              {formik.touched.membershipType && formik.errors.membershipType ? (
                <div className="text-red-500 text-sm mt-2 pl-2">
                  {formik.errors.membershipType}
                </div>
              ) : null}
            </div>
          </section>

          {/* Section 2: Personal Info */}
          <section className="bg-gradient-to-r from-gray-50 to-white p-6 rounded-xl border border-gray-100">
            <div className="flex items-center mb-6">
              <div className="w-2 h-8 bg-lime-500 rounded-full mr-3"></div>
              <h2 className="text-2xl font-bold text-gray-900">
                Personal Information
              </h2>
            </div>
            <div className="grid md:grid-cols-2 gap-6">
              {[
                { name: "rank", placeholder: "Rank" },
                { name: "baNumber", placeholder: "BA Number" },
                { name: "firstName", placeholder: "First Name" },
                { name: "lastName", placeholder: "Last Name" },
                // {
                //   name: "fatherOrHusbandName",
                //   placeholder: "Father's/Husband's Name",
                // },
                { name: "nationality", placeholder: "Nationality" },
                { name: "occupation", placeholder: "Occupation" },
                { name: "bloodGroup", placeholder: "Blood Group" },
                {
                  name: "mobile",
                  placeholder: "11 digit Mobile Number",
                  type: "tel",
                },
              ].map((field) => (
                <div key={field.name}>
                  <input
                    type={field.type || "text"}
                    name={field.name}
                    placeholder={field.placeholder}
                    className="p-4 rounded-xl bg-gray-50 w-full outline-none border border-gray-200 focus:border-lime-500 focus:ring-2 focus:ring-lime-200 transition duration-200"
                    value={formik.values[field.name]}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched[field.name] && formik.errors[field.name] ? (
                    <div className="text-red-500 text-sm mt-2 pl-2">
                      {formik.errors[field.name]}
                    </div>
                  ) : null}
                </div>
              ))}
            </div>
            <div className="my-6">
              <div className="relative">
                <select
                  name="gender"
                  className="p-4 bg-gray-50 rounded-xl w-full outline-none border border-gray-200 focus:border-lime-500 focus:ring-2 focus:ring-lime-200 transition duration-200 appearance-none"
                  value={formik.values.gender}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  <option value="">Select Gender</option>
                  <option value="MALE">Male</option>
                  <option value="FEMALE">Female</option>
                  <option value="OTHER">Other</option>
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-3 text-gray-400">
                  <svg
                    className="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
              </div>
              {formik.touched.gender && formik.errors.gender ? (
                <div className="text-red-500 text-sm mt-2 pl-2">
                  {formik.errors.gender}
                </div>
              ) : null}
            </div>

            {["officialAddress", "presentAddress", "permanentAddress"].map(
              (field) => (
                <div key={field} className="mt-6">
                  <input
                    type="text"
                    name={field}
                    placeholder={field
                      .replace(/([A-Z])/g, " $1")
                      .replace(/^./, (str) => str.toUpperCase())}
                    className="p-4 rounded-xl bg-gray-50 w-full outline-none border border-gray-200 focus:border-lime-500 focus:ring-2 focus:ring-lime-200 transition duration-200 resize-none"
                    value={formik.values[field]}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched[field] && formik.errors[field] ? (
                    <div className="text-red-500 text-sm mt-2 pl-2">
                      {formik.errors[field]}
                    </div>
                  ) : null}
                </div>
              )
            )}
            <div className="my-6">
              {/* <h3 className="text-lg font-semibold text-gray-800 mb-4">
                National ID Details (Required)
              </h3> */}
              <div className="grid md:grid-cols-2 gap-6">
                {[
                  { name: "nationalId", placeholder: "National ID Number" },
                  // { name: "nidName", placeholder: "Name as in NID" },
                  // {
                  //   name: "nidFathersName",
                  //   placeholder: "Father's Name (from NID)",
                  // },
                  // {
                  //   name: "nidMothersName",
                  //   placeholder: "Mother's Name (from NID)",
                  // },
                ].map((field) => (
                  <div key={field.name}>
                    <input
                      type="text"
                      name={field.name}
                      placeholder={field.placeholder}
                      className="p-4 rounded-xl bg-gray-50 w-full outline-none border border-gray-200 focus:border-lime-500 focus:ring-2 focus:ring-lime-200 transition duration-200"
                      value={formik.values[field.name]}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched[field.name] && formik.errors[field.name] ? (
                      <div className="text-red-500 text-sm mt-2 pl-2">
                        {formik.errors[field.name]}
                      </div>
                    ) : null}
                  </div>
                ))}

                {/* <div>
                  <label className="block text-sm text-gray-600 mb-2 pl-1">
                    Date of Birth (from NID)
                  </label>
                  <input
                    type="date"
                    name="nidDob"
                    className="p-4 rounded-xl bg-gray-50 w-full outline-none border border-gray-200 focus:border-lime-500 focus:ring-2 focus:ring-lime-200 transition duration-200"
                    value={formik.values.nidDob}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.nidDob && formik.errors.nidDob ? (
                    <div className="text-red-500 text-sm mt-2 pl-2">
                      {formik.errors.nidDob}
                    </div>
                  ) : null}
                </div> */}

                <div>
                  <label className="block mb-3 font-semibold text-gray-700">
                    Upload NID (Max 5MB)
                  </label>
                  <input
                    type="file"
                    accept="image/*"
                    name="nidCopy"
                    className="block w-full bg-gray-50 p-4 rounded-xl border border-gray-200 focus:border-lime-500 focus:ring-2 focus:ring-lime-200 transition duration-200 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-lime-100 file:text-lime-700 hover:file:bg-lime-200"
                    onChange={handleFileChange("nidCopy")}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.nidCopy && formik.errors.nidCopy ? (
                    <div className="text-red-500 text-sm mt-2 pl-2">
                      {formik.errors.nidCopy}
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
            <div>
              <label className="block mb-3 font-semibold text-gray-700">
                Upload Your Photo (Max 5MB)
              </label>
              <input
                type="file"
                name="photo"
                accept="image/*"
                className="block w-full bg-gray-50 p-4 rounded-xl border border-gray-200 focus:border-lime-500 focus:ring-2 focus:ring-lime-200 transition duration-200 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-lime-100 file:text-lime-700 hover:file:bg-lime-200"
                onChange={handleFileChange("photo")}
                onBlur={formik.handleBlur}
              />
              {formik.touched.photo && formik.errors.photo ? (
                <div className="text-red-500 text-sm mt-2 pl-2">
                  {formik.errors.photo}
                </div>
              ) : null}
            </div>
          </section>

          {/* Section 3: Income */}
          <section className="bg-gradient-to-r from-gray-50 to-white p-6 rounded-xl border border-gray-100">
            <div className="flex items-center mb-6">
              <div className="w-2 h-8 bg-lime-500 rounded-full mr-3"></div>
              <h2 className="text-2xl font-bold text-gray-900">
                Income & Tax Details
              </h2>
            </div>
            <div>
              <input
                type="text"
                name="monthlyIncome"
                placeholder="Monthly Income"
                className="p-4 rounded-xl bg-gray-50 w-full mb-6 outline-none border border-gray-200 focus:border-lime-500 focus:ring-2 focus:ring-lime-200 transition duration-200"
                value={formik.values.monthlyIncome}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.monthlyIncome && formik.errors.monthlyIncome ? (
                <div className="text-red-500 text-sm mt-2 pl-2">
                  {formik.errors.monthlyIncome}
                </div>
              ) : null}
            </div>
            <div>
              <label className="block mb-3 font-semibold text-gray-700">
                Upload Income Tax Return (Max 5MB)
              </label>
              <div className="relative">
                <input
                  type="file"
                  accept="image/*"
                  name="incomeTaxReturn"
                  className="block w-full bg-gray-50 p-4 rounded-xl border border-gray-200 focus:border-lime-500 focus:ring-2 focus:ring-lime-200 transition duration-200 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-lime-100 file:text-lime-700 hover:file:bg-lime-200"
                  onChange={handleFileChange("incomeTaxReturn")}
                  onBlur={formik.handleBlur}
                />
              </div>
              {formik.touched.incomeTaxReturn &&
              formik.errors.incomeTaxReturn ? (
                <div className="text-red-500 text-sm mt-2 pl-2">
                  {formik.errors.incomeTaxReturn}
                </div>
              ) : null}
            </div>
          </section>

          {/* Section 4: Identity Documents */}
          {/* <section className="bg-gradient-to-r from-gray-50 to-white p-6 rounded-xl border border-gray-100">
            <div className="flex items-center mb-6">
              <div className="w-2 h-8 bg-lime-500 rounded-full mr-3"></div>
              <h2 className="text-2xl font-bold text-gray-900">
                Identity Documents
              </h2>
            </div>
            <div className="mb-6">
              <h3 className="text-lg font-semibold text-gray-800 mb-4">
                National ID Details (Required)
              </h3>
              <div className="grid md:grid-cols-2 gap-6">
                {[
                  { name: "nationalId", placeholder: "National ID Number" },
                  // { name: "nidName", placeholder: "Name as in NID" },
                  // {
                  //   name: "nidFathersName",
                  //   placeholder: "Father's Name (from NID)",
                  // },
                  // {
                  //   name: "nidMothersName",
                  //   placeholder: "Mother's Name (from NID)",
                  // },
                ].map((field) => (
                  <div key={field.name}>
                    <input
                      type="text"
                      name={field.name}
                      placeholder={field.placeholder}
                      className="p-4 rounded-xl bg-gray-50 w-full outline-none border border-gray-200 focus:border-lime-500 focus:ring-2 focus:ring-lime-200 transition duration-200"
                      value={formik.values[field.name]}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched[field.name] && formik.errors[field.name] ? (
                      <div className="text-red-500 text-sm mt-2 pl-2">
                        {formik.errors[field.name]}
                      </div>
                    ) : null}
                  </div>
                ))}

                <div>
                  <label className="block text-sm text-gray-600 mb-2 pl-1">
                    Date of Birth (from NID)
                  </label>
                  <input
                    type="date"
                    name="nidDob"
                    className="p-4 rounded-xl bg-gray-50 w-full outline-none border border-gray-200 focus:border-lime-500 focus:ring-2 focus:ring-lime-200 transition duration-200"
                    value={formik.values.nidDob}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.nidDob && formik.errors.nidDob ? (
                    <div className="text-red-500 text-sm mt-2 pl-2">
                      {formik.errors.nidDob}
                    </div>
                  ) : null}
                </div>

                <div>
                  <label className="block mb-3 font-semibold text-gray-700">
                    Upload NID (Max 5MB)
                  </label>
                  <input
                    type="file"
                    accept="image/*"
                    name="nidCopy"
                    className="block w-full bg-gray-50 p-4 rounded-xl border border-gray-200 focus:border-lime-500 focus:ring-2 focus:ring-lime-200 transition duration-200 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-lime-100 file:text-lime-700 hover:file:bg-lime-200"
                    onChange={handleFileChange("nidCopy")}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.nidCopy && formik.errors.nidCopy ? (
                    <div className="text-red-500 text-sm mt-2 pl-2">
                      {formik.errors.nidCopy}
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </section> */}

          {/* Section 5: Family */}
          <section className="bg-gradient-to-r from-gray-50 to-white p-6 rounded-xl border border-gray-100">
            <div className="flex items-center mb-6">
              <div className="w-2 h-8 bg-lime-500 rounded-full mr-3"></div>
              <h2 className="text-2xl font-bold text-gray-900">
                Family Details
              </h2>
            </div>

            <h4 className="text-lg font-semibold text-gray-800 mb-4">
              Spouse (if any)
            </h4>
            <div className="space-y-4 mb-8">
              {[
                { name: "spouseName", placeholder: "Spouse Name" },
                { name: "spouseOccupation", placeholder: "Spouse Occupation" },
                { name: "spouseAddress", placeholder: "Spouse Address" },
              ].map((field) => (
                <div key={field.name}>
                  <input
                    type="text"
                    name={field.name}
                    placeholder={field.placeholder}
                    className="p-4 rounded-xl bg-gray-50 w-full outline-none border border-gray-200 focus:border-lime-500 focus:ring-2 focus:ring-lime-200 transition duration-200"
                    value={formik.values[field.name]}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched[field.name] && formik.errors[field.name] ? (
                    <div className="text-red-500 text-sm mt-2 pl-2">
                      {formik.errors[field.name]}
                    </div>
                  ) : null}
                </div>
              ))}
            </div>

            <h4 className="text-lg font-semibold text-gray-800 mb-4">
              Children/Dependants below 21 (if any)
            </h4>
            {formik.values.children &&
              formik.values.children.length > 0 &&
              formik.values.children.map((child, i) => (
                <div
                  key={i}
                  className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6 p-4 bg-gray-50 rounded-xl border border-gray-200"
                >
                  <div>
                    <input
                      type="text"
                      placeholder="Name"
                      className="p-3 rounded-lg bg-white w-full outline-none border border-gray-200 focus:border-lime-500 focus:ring-2 focus:ring-lime-200 transition duration-200"
                      value={child.name}
                      onChange={(e) => {
                        const updatedChildren = [...formik.values.children];
                        updatedChildren[i].name = e.target.value;
                        formik.setFieldValue("children", updatedChildren);
                      }}
                      onBlur={formik.handleBlur}
                    />
                  </div>

                  <div>
                    <label className="block text-sm text-gray-600 mb-1 pl-1">
                      Date of Birth
                    </label>
                    <input
                      type="date"
                      placeholder="Date of Birth"
                      className="p-3 rounded-lg bg-white w-full outline-none border border-gray-200 focus:border-lime-500 focus:ring-2 focus:ring-lime-200 transition duration-200"
                      value={child.dob}
                      onChange={(e) => {
                        const updatedChildren = [...formik.values.children];
                        updatedChildren[i].dob = e.target.value;
                        formik.setFieldValue("children", updatedChildren);
                      }}
                      onBlur={formik.handleBlur}
                    />
                  </div>

                  <div>
                    <input
                      type="text"
                      placeholder="Relationship"
                      className="p-3 rounded-lg bg-white w-full outline-none border border-gray-200 focus:border-lime-500 focus:ring-2 focus:ring-lime-200 transition duration-200"
                      value={child.gender}
                      onChange={(e) => {
                        const updatedChildren = [...formik.values.children];
                        updatedChildren[i].gender = e.target.value;
                        formik.setFieldValue("children", updatedChildren);
                      }}
                      onBlur={formik.handleBlur}
                    />
                  </div>

                  <div className="flex items-center justify-end">
                    {formik.values.children.length > 1 && (
                      <button
                        type="button"
                        onClick={() => removeChild(i)}
                        className="p-2 text-red-500 hover:text-red-700 hover:bg-red-50 rounded-lg transition duration-200"
                        title="Remove Child"
                      >
                        <svg
                          className="w-6 h-6"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M6 18L18 6M6 6l12 12"
                          />
                        </svg>
                      </button>
                    )}
                  </div>
                </div>
              ))}
            <button
              type="button"
              onClick={addChild}
              className="inline-flex items-center text-lime-600 hover:text-lime-800 font-medium hover:bg-lime-50 px-4 py-2 rounded-lg transition duration-200"
            >
              <svg
                className="w-5 h-5 mr-2"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
                  clipRule="evenodd"
                />
              </svg>
              Add{" "}
              {formik.values.children.length >= 1 ? "Another Child" : "Child"}
            </button>
          </section>

          {/* Section 6: Golf Club Details */}
          <section className="bg-gradient-to-r from-gray-50 to-white p-6 rounded-xl border border-gray-100">
            <div className="flex items-center mb-6">
              <div className="w-2 h-8 bg-lime-500 rounded-full mr-3"></div>
              <h2 className="text-2xl font-bold text-gray-900">
                Golf Club Details (Optional)
              </h2>
            </div>
            <div className="space-y-4">
              <div>
                <input
                  type="text"
                  name="golfClubMembership"
                  placeholder="Name of Previous Golf Club Membership (if any)"
                  className="p-4 rounded-xl bg-gray-50 w-full outline-none border border-gray-200 focus:border-lime-500 focus:ring-2 focus:ring-lime-200 transition duration-200"
                  value={formik.values.golfClubMembership}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.golfClubMembership &&
                formik.errors.golfClubMembership ? (
                  <div className="text-red-500 text-sm mt-2 pl-2">
                    {formik.errors.golfClubMembership}
                  </div>
                ) : null}
              </div>

              {/* <div>
                <input
                  type="text"
                  name="officialHandicap"
                  placeholder="Official Handicap (if any)"
                  className="p-4 rounded-xl bg-gray-50 w-full outline-none border border-gray-200 focus:border-lime-500 focus:ring-2 focus:ring-lime-200 transition duration-200"
                  value={formik.values.officialHandicap}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.officialHandicap &&
                formik.errors.officialHandicap ? (
                  <div className="text-red-500 text-sm mt-2 pl-2">
                    {formik.errors.officialHandicap}
                  </div>
                ) : null}
              </div> */}
            </div>
          </section>

          {/* Section 7: Photos */}
          {/* <section className="bg-gradient-to-r from-gray-50 to-white p-6 rounded-xl border border-gray-100">
            <div className="flex items-center mb-6">
              <div className="w-2 h-8 bg-lime-500 rounded-full mr-3"></div>
              <h2 className="text-2xl font-bold text-gray-900">Photos</h2>
            </div>
            <label className="block mb-3 font-semibold text-gray-700">
              Upload Your Photo (passport size, Max 5MB)
            </label>
            <input
              type="file"
              name="photo"
              accept="image/*"
              className="block w-full bg-gray-50 p-4 rounded-xl border border-gray-200 focus:border-lime-500 focus:ring-2 focus:ring-lime-200 transition duration-200 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-lime-100 file:text-lime-700 hover:file:bg-lime-200"
              onChange={handleFileChange("photo")}
              onBlur={formik.handleBlur}
            />
            {formik.touched.photo && formik.errors.photo ? (
              <div className="text-red-500 text-sm mt-2 pl-2">
                {formik.errors.photo}
              </div>
            ) : null}
          </section> */}

          {/* Section 8: Account Registration */}
          <section className="bg-gradient-to-r from-gray-50 to-white p-6 rounded-xl border border-gray-100">
            <div className="flex items-center mb-6">
              <div className="w-2 h-8 bg-lime-500 rounded-full mr-3"></div>
              <h2 className="text-2xl font-bold text-gray-900">
                Create Your Account
              </h2>
            </div>
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <svg
                      className="w-5 h-5 text-gray-400"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                      <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                    </svg>
                  </div>
                  <input
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    className="pl-10 p-4 rounded-xl bg-gray-50 w-full outline-none border border-gray-200 focus:border-lime-500 focus:ring-2 focus:ring-lime-200 transition duration-200"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
                {formik.touched.email && formik.errors.email ? (
                  <div className="text-red-500 text-sm mt-2 pl-2">
                    {formik.errors.email}
                  </div>
                ) : null}
              </div>
            </div>
          </section>

          {/* Submit Button */}
          <div className="pt-6">
            <button
              type="submit"
              className="w-full bg-gradient-to-r from-lime-500 to-lime-600 hover:from-lime-600 hover:to-lime-700 text-white py-4 rounded-xl font-bold text-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:transform-none"
              disabled={formik.isSubmitting || isSendingOtp}
            >
              {formik.isSubmitting || isSendingOtp ? (
                <span className="flex items-center justify-center">
                  <svg
                    className="animate-spin -ml-1 mr-3 h-6 w-6 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  {isSendingOtp
                    ? "Sending Verification Code..."
                    : "Processing..."}
                </span>
              ) : (
                <span className="flex items-center justify-center">
                  <svg
                    className="w-6 h-6 mr-3"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </svg>
                  SEND VERIFICATION CODE
                </span>
              )}
            </button>
            <p className="text-center text-gray-500 text-sm mt-4">
              You'll receive a 6-digit code to verify your email address
            </p>
          </div>
        </div>
      </form>
    </div>
  );
};

export default DefenceOfficer;
